export default "__VITE_ASSET__BzdjT6OL__"